module.exports = __webpack_public_path__ + "static/media/STRAP.da8668c1.svg";